import {APIRequest} from "./APIRequest.js";
import {signKBTransactionJWT} from "../Crypto/utils";
import {MyServices} from "../constants";

export const API_URL_IMAGE_TO_TEXT = MyServices["gcp.textDetection"].url;

export const imageToTextAPI = async (KB, selectedFile, textOnly) => {

    const transactionJWT = await signKBTransactionJWT({
        toAccountId: MyServices["gcp.textDetection"]?.accountId,
        ...KB,
        message: 'speech recognition'})

    try {
        const formData = new FormData();
        formData.append("file", selectedFile);
        const response = await APIRequest('post', API_URL_IMAGE_TO_TEXT, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'transaction-jwt': transactionJWT
            }
        })

        if (textOnly) {
            return { detections: response?.data?.detections[0]?.txt }
        } else {
            return response?.data;
        }

    } catch (error) {
        if (error.response && error.response.data && error.response.data.hasPages) {
            return {hasPages: true};
        }
        console.error('API request error:', error);
        throw error;
    }
};